import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfAccordionCards, { EfAccordionCardType } from '@elem/ui/ef-accordion-cards';
import { PageNavType } from '../PageNav';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.ReliableUPS');
    const list: EfAccordionCardType[] = [
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157089439/7_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081308486/rel-pc-1.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157148841/7_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081307905/rel-pad-1.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157214773/7_1.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081307352/rel-h5-1.jpg',
            title: t('card1_title'),
            desc: t('card1_desc'),
        },
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157089635/7_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081308654/rel-pc-2.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157149023/7_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081308086/rel-pad-2.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157214420/7_2.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081307550/rel-h5-2.jpg',
            title: t('card2_title'),
            desc: t('card2_desc'),
        },
        {
            pc: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157089806/7_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081308830/rel-pc-3.jpg',
            pad: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157170024/7_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081308280/rel-pad-3.jpg',
            h5: IS_UK_SITE
                ? 'https://websiteoss.ecoflow.com/upload/image/1741157214594/7_3.png'
                : 'https://websiteoss.ecoflow.com/upload/image/1741081307721/rel-h5-3.jpg',
            title: t('card3_title'),
            desc: t('card3_desc'),
        },
    ];

    return (
        <div className={styles.TheComp} id={PageNavType.What}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <EfAccordionCards list={list} type="page" />
            <EfSpec />
        </div>
    );
}
